export const GridGlow = () => (
  <div aria-hidden className="pointer-events-none absolute inset-0 [mask-image:radial-gradient(70%_60%_at_50%_0%,_black,_transparent)]">
    <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[60rem] h-[30rem] rounded-full bg-fuchsia-500/20 blur-3xl"></div>
    <div className="absolute top-20 left-10 w-72 h-72 bg-indigo-500/20 rounded-full blur-3xl"></div>
  </div>
);
